/* eslint-disable max-len */
import { createSvgIcon } from "../utils";

const Erase = createSvgIcon(
    <>
        <path d="M18.708 13.797a.375.375 0 00-.375.375v7.082a.375.375 0 00.75 0v-7.082a.375.375 0 00-.375-.375zM14.287 13.797a.375.375 0 00-.375.375v7.082a.375.375 0 00.75 0v-7.082a.375.375 0 00-.375-.375z" />
        <path d="M11.064 12.763v9.232c0 .546.2 1.058.55 1.426.348.369.832.578 1.339.579h7.09c.506 0 .99-.21 1.338-.579.35-.368.55-.88.55-1.426v-9.232a1.431 1.431 0 00-.367-2.814h-1.919V9.48A1.472 1.472 0 0018.161 8h-3.327a1.472 1.472 0 00-1.484 1.48v.469h-1.918a1.432 1.432 0 00-.368 2.814zm8.978 10.488h-7.09c-.64 0-1.138-.55-1.138-1.256v-9.199h9.367v9.2c0 .704-.498 1.255-1.139 1.255zM14.1 9.48a.722.722 0 01.735-.732h3.327a.722.722 0 01.735.731v.469h-4.797V9.48zm-2.668 1.217h10.133a.674.674 0 010 1.349H11.43a.675.675 0 010-1.35z" />
        <path d="M16.497 13.797a.375.375 0 00-.375.375v7.082a.375.375 0 00.75 0v-7.082a.375.375 0 00-.375-.375z" />
    </>,
    "Erase",
);

export default Erase;
